














/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import EchartOption from '@/common/const/e-chart-options';
import _ from 'lodash';
import axios from 'axios';
@Component({
  components: {}
})
export default class ParkMap extends Vue {
  @Prop()
  mapData!: any; //图表数据

  @Prop()
  mapRanges!: any[]; //图表数据范围

  parkMapVisible = false;
  loading: boolean = false;
  //获取地图数据
  getMapData() {
    let ranges = [];
    if (this.mapData && this.mapData.length) {
      let maxValue = _.maxBy<any>(this.mapData, i => i.parkingNum).parkingNum;
      this.maxNum = maxValue;
      if (maxValue < 3) {
        ranges = [1, 2];
      } else {
        let tick = Math.round(maxValue / 3);
        ranges = [tick, tick * 2];
      }
    }
    return ranges;
  }
  maxNum = 1;

  //颜色类型
  colorStyleList: any[] = [
    //最少
    {
      colorStops: [
        {
          offset: 0,
          color: 'rgba(63, 207, 246, 1)' // 0% 处的颜色
        },
        {
          offset: 0.3,
          color: 'rgba(63, 207, 246, 1)' // 100% 处的颜色
        },
        {
          offset: 1,
          color: 'rgba(63, 207, 246, 0)' // 100% 处的颜色
        }
      ],
      color: 'rgba(63, 207, 246, 1)'
    },
    {
      colorStops: [
        {
          offset: 0,
          color: 'rgba(115, 108, 240, 1)' // 0% 处的颜色
        },
        {
          offset: 0.3,
          color: 'rgba(115, 108, 240, 1)' // 100% 处的颜色
        },
        {
          offset: 1,
          color: 'rgba(115, 108, 240, 0)' // 100% 处的颜色
        }
      ],
      color: 'rgba(115, 108, 240, 1)'
    },
    //最多
    {
      colorStops: [
        {
          offset: 0,
          color: 'rgba(255, 110, 89, 1)' // 0% 处的颜色
        },
        {
          offset: 0.3,
          color: 'rgba(255, 110, 89,1)' // 100% 处的颜色
        },
        {
          offset: 1,
          color: 'rgba(255, 110, 89, 0)' // 100% 处的颜色
        }
      ],
      color: 'rgba(255, 110, 89, 1)'
    }
  ];
  options: EchartOption = new EchartOption();
  isData: boolean = true;

  mapName: String = 'china';
  // 是否钻入省份
  inProvince: boolean = false;

  provinces: any = {
    // 23个省

    台湾: 'taiwan',

    河北: 'hebei',

    山西: 'shanxi',

    辽宁: 'liaoning',

    吉林: 'jilin',

    黑龙江: 'heilongjiang',

    江苏: 'jiangsu',

    浙江: 'zhejiang',

    安徽: 'anhui',

    福建: 'fujian',

    江西: 'jiangxi',

    山东: 'shandong',

    河南: 'henan',

    湖北: 'hubei',

    湖南: 'hunan',

    广东: 'guangdong',

    海南: 'hainan',

    四川: 'sichuan',

    贵州: 'guizhou',

    云南: 'yunnan',

    陕西: 'shanxi1',

    甘肃: 'gansu',

    青海: 'qinghai',

    // 5个自治区

    新疆: 'xinjiang',

    广西: 'guangxi',

    内蒙古: 'neimenggu',

    宁夏: 'ningxia',

    西藏: 'xizang',

    // 4个直辖市

    北京: 'beijing',

    天津: 'tianjin',

    上海: 'shanghai',

    重庆: 'chongqing',

    // 2个特别行政区

    香港: 'xianggang',

    澳门: 'aomen'
  };

  clickFlag: boolean = false;
  getPopupContainer() {
    return this.$refs.panel;
  }

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'item',
      formatter: function(params, ticket, callback) {
        return params.data
          ? `
        <div class="parking-overview-tooltip">
          <div class="parking-overview-tooltip-title"> 今日统计</div>
          <div class="parking-overview-tooltip-item v1">城市名称：<span>${
            params.data.name ? params.data.name : ''
          }</span></div>
          <div class="parking-overview-tooltip-item v2">车场数量：<span>${
            params.data.value[2] ? params.data.value[2] : 0
          }</span></div>
           <div class="parking-overview-tooltip-item v3">车流量：<span>${
             params.data.trafficFlow ? params.data.trafficFlow : 0
           }</span></div>

        </div>
      `
          : '';
      }
    };
  }

  get grid() {
    return {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    };
  }

  get visualMap() {
    return {
      show: false,
      orient: 'horizontal',
      left: 'center',
      bottom: 0,
      type: 'piecewise',
      pieces: this.pieces
    };
  }

  get geo() {
    return {
      map: this.mapName,
      zoom: 1.13,
      roam: false,
      // start两层地图
      // label: {
      //   show: false,
      // },
      // itemStyle: {
      //   normal: {
      //     areaColor: 'rgba(24, 33, 71,0)',
      //     borderWidth: 4, //设置外层边框
      //     borderColor: 'rgba(62, 108, 196, 1)',
      //   },
      //   emphasis: {
      //     areaColor: null,
      //   },
      // },
      // end两层地图
      // start一层地图
      label: {
        normal: {
          show: true,
          color: '#7087bc'
        },
        emphasis: {
          show: true,
          color: '#7087bc'
        }
      },
      itemStyle: {
        normal: {
          areaColor: 'rgba(40,50,108, 0.3)', //40,50,108
          borderWidth: 1, //设置外层边框
          borderColor: 'rgba(62, 108, 196, 1)'
        },
        emphasis: {
          color: 'rgba(18, 26, 58, 0)', //图形的颜色不是字体的颜色
          borderColor: 'rgba(62, 108, 196, 1)'
        }
      }
      // end一层地图
    };
  }

  get series() {
    // let ranges = this.getMapData()
    let ranges = this.mapRanges;
    const self = this;
    return [
      {
        type: 'map',
        map: 'china',
        zoom: 1.13,
        roam: false,
        // start一层地图
        geoIndex: 0
        // end一层地图

        // start两层地图
        // label: {
        //   show: true,
        //   color: 'rgba(67, 84, 154, 1)',
        // },
        // itemStyle: {
        //   normal: {
        //     areaColor: 'rgba(24, 33, 71,1)',
        //     borderColor: 'rgba(62, 108, 196, 0.3)',
        //     borderWidth: 0.5,
        //   },
        //   emphasis: {
        //     areaColor: null,
        //     label: {
        //       color: '#fff',
        //     },
        //   },
        // },
        // end两层地图
      },
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        rippleEffect: {
          brushType: 'stroke' //'stroke,fill',
        },
        itemStyle: {
          color: function(params) {
            let parkingNum = params.value[2];
            let colorStyle: Record<string, any> = {};
            if (parkingNum > ranges[1]) {
              colorStyle = self.colorStyleList[2];
            } else if (parkingNum <= ranges[0]) {
              colorStyle = self.colorStyleList[0];
            } else {
              colorStyle = self.colorStyleList[1];
            }
            return colorStyle.color;
          }
        },
        symbolSize: '8',
        data: this.mapData.map(function(itemOpt) {
          return {
            name: itemOpt.cityName,
            trafficFlow: itemOpt.trafficFlow,
            provinceName: itemOpt.provinceName,
            provinceId: itemOpt.provinceId,
            value: [
              itemOpt.longitude || '',
              itemOpt.latitude || '',
              itemOpt.parkingNum || '0' //数量
            ],
            label: {
              emphasis: {
                position: 'right',
                show: false
              }
            },
            zlevel: 99999
          };
        })
      }
    ];
  }
  mounted() {
    this.registerProvinceMap();
  }

  // registerProvinceMap() {
  //   let chart: any = this.$refs.chart
  //   echarts.registerMap('china', this.mapJson['china'])
  //   for (let k in this.provinces) {
  //     let mapName = this.provinces[k]
  //     let src = this.mapJson[mapName]
  //     echarts.registerMap(mapName, src)
  //   }
  // }

  refreshMap() {
    const options: EchartOption = new EchartOption();
    options.setLegend({
      show: false
    });
    options.setGrid(this.grid);
    // options.setVisualMap(this.visualMap)
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setGeo(this.geo);
    options.setTooltip(this.toolTip);
    this.options = options;
    this.clickFlag = false;
  }

  async getMapJson() {
    let mapJson = window.localStorage.getItem('smart-parking-map-json');
    if (!mapJson) {
      this.loading = true;
      const result = await axios.get(`${window.location.origin}/static/config/map-json/map-json.json`);
      mapJson = JSON.stringify(result);
      // 把json存入storage
      window.localStorage.setItem('smart-parking-map-json', mapJson);
      this.loading = false;
    }
    try {
      return JSON.parse(mapJson);
    } catch (e) {
      this.clickFlag = false;
      console.log('地图获取报错===》', e);
    }
  }
  async registerProvinceMap() {
    const res = await this.getMapJson();
    let chart: any = this.$refs.chart;
    const { data } = res;
    echarts.registerMap('china', data['china']);
    for (let k in this.provinces) {
      let mapName = this.provinces[k];
      let src = data[mapName];
      echarts.registerMap(mapName, src);
    }
  }
  // 点击地图 下钻
  chartClick(params: { name: string | number; data: { nodeId: any } }) {
    if (this.clickFlag) return;
    if (this.inProvince) {
      this.clickFlag = true;
      this.mapName = 'china';
      this.inProvince = false;
      this.$emit('updateProvinceId', null);
    } else {
      const dataP = this.mapData.find(i => i.provinceName == params.name);
      const dataCity = this.mapData.find(i => i.cityName == params.name);
      if (!(dataP || dataCity)) return this.$message.info('该省份暂无车场，无法下钻');
      if (dataP) {
        if (this.provinces[params.name]) {
          this.clickFlag = true;
          const mapName = this.provinces[params.name];
          this.mapName = mapName;
          this.inProvince = true;
          this.$emit('updateProvinceId', dataP.provinceId);
        }
      }
      if (dataCity) {
        this.clickFlag = true;
        const mapName = this.provinces[dataCity.provinceName];
        this.mapName = mapName;
        this.inProvince = true;
        this.$emit('updateProvinceId', dataCity.provinceId);
      }
    }
  }
}
